import { useState } from "react";
//@MUI
import { Button, Modal, TableCell, TableRow } from "@material-ui/core";
//@Components
import { Chip, Tooltip, Typography } from "@mui/material";
import { ChatText } from "phosphor-react";
import { Edit3 } from "react-feather";
import { fdelete } from "../../../API/callsAPI";
import DateAndTimeViewer from "../../Utilities/DateAndTimeViewer/DateAndTimeViewer.component";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import ImageViewer from "../../Utilities/ImageViewer/ImageViewer.component";
import NoThumbnail from "../../Utilities/NoThumbnail.component";
import StatusDropDown from "../../Utilities/StatusDropDown/StatusDropDown.component";
import TaskDetailsOnHover from "../../Utilities/TaskDetailsOnHover/TaskDetailsOnHover";
import ShotVersionEditVersionModal from "../ShotVersionPageModals/ShotVersionEditVersionModal";
import useStyles from "./ShotVersionList.styles";

export default function Shotversionslist(props) {
  const classes = useStyles();
  const [isEditShotVersionModalOpen, setEditShotVersionModalOpen] =
    useState(false);

  const [isDeleteShotVersionModalOpen, setDeleteShotVersionModalOpen] =
    useState(false);
  const [deleteData, setDeleteData] = useState({});

  function handleEditShotVersionModalOpenState(e) {
    e?.stopPropagation();
    e?.preventDefault();
    setEditShotVersionModalOpen(!isEditShotVersionModalOpen);
  }

  function handleDeleteShotVersionModalOpenState(e, data) {
    e?.stopPropagation();
    e?.preventDefault();
    setDeleteData(data);
    setDeleteShotVersionModalOpen(!isDeleteShotVersionModalOpen);
  }

  const handleDeleteShotVersion = async () => {
    try {
      await fdelete({
        url: `trackables/shot-version/${deleteData?.id}/`,
      });

      props.updateRefreshCounter();
      setDeleteShotVersionModalOpen(false);
      setEditShotVersionModalOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <TableRow
        key={props.data.id}
        hover
        onClick={(e) => props.openShotDetailModal(props.data)}
        style={{
          cursor: "pointer",
          padding: "0px",
          width: "100%",
        }}
      >
        <TableCell align="left" className={classes.shotVersionListTableCellTwo}>
          <div style={{ display: "flex" }}>
            {props.data.thumbnail ? (
              <ImageViewer
                url={props.data.thumbnail}
                sliderState={props.shotVersionToggle ? 25 : 0}
              />
            ) : (
              <NoThumbnail sliderState={props.shotVersionToggle ? 25 : 0} />
            )}
            <p style={{ marginLeft: "10px" }}>
              {props.data.name ? props.data.name : "No Name"}
            </p>
          </div>
        </TableCell>
        <TableCell align="center" className={classes.shotVersionListTableCell}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DateAndTimeViewer dateAndTime={props?.data?.updated_at} />
          </div>
        </TableCell>
        <TableCell align="center" className={classes.shotVersionListTableCell}>
          <div className={classes.flexCenter}>
            <StatusDropDown
              url={`trackables/shot-version/${props.data.id}/`}
              updateRefreshCounter={props.updateRefreshCounter}
              statusList={props.status}
              currStatus={props.data.status}
            />
          </div>
        </TableCell>
        <TableCell align="center" className={classes.shotVersionListTableCell}>
          <span>
            {props?.data?.created_by.first_name
              ? props.data.created_by.first_name +
                " " +
                props.data.created_by.last_name
              : " "}
          </span>
        </TableCell>
        <TableCell align="center" className={classes.shotVersionListTableCell}>
          {props.data && props.data.task && props.data.task.id ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Tooltip
                describeChild
                arrow
                placement="right"
                title={<TaskDetailsOnHover task={props.data.task} />}
                slotProps={{
                  popper: {
                    sx: {
                      "& .MuiTooltip-tooltip": {
                        padding: "0px",
                        backgroundColor: "transparent",
                        border: "none",
                      },
                      "& .MuiTooltip-arrow": {
                        color: "#6C65D9",
                      },
                    },
                  },
                }}
              >
                <Chip
                  sx={{
                    width: "max-content",
                    cursor: "pointer",
                    fontSize: {
                      xs: "8px !important",
                      sm: "10px !important",
                      md: "10px !important",
                      lg: "12px !important",
                      xl: "14px !important",
                    },
                    color: "#f9f9f9 !important",
                    padding: "5px 6px !important",
                  }}
                  size="small"
                  label={props.data.task.name ?? ""}
                  variant="outlined"
                />
              </Tooltip>
            </div>
          ) : (
            <Typography
              sx={{
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              No Related Task
            </Typography>
          )}
        </TableCell>
        <TableCell
          align="center"
          className={classes.shotVersionListTableCellTwo}
        >
          <div className={classes.flexCenter}>
            <ChatText
              size={17}
              color="#606479"
              weight="fill"
              style={{ marginRight: "7px" }}
            />
            {props.data.related_comments_number}
          </div>
        </TableCell>
        <TableCell
          align="right"
          className={classes.shotVersionListTableCellTwo}
        >
          <Button
            style={{
              minWidth: "36px",
              borderRadius: "6px",
              padding: "6px",
              margin: "2px",
            }}
            onClick={(e) => {
              handleEditShotVersionModalOpenState(e);
            }}
          >
            <Edit3 />
          </Button>
        </TableCell>
      </TableRow>
      <Modal
        className={classes.shotVersionPageModals}
        open={isEditShotVersionModalOpen}
        onClose={(e) => {
          setEditShotVersionModalOpen(false);
          e.stopPropagation();
        }}
      >
        <ShotVersionEditVersionModal
          data={props.data}
          sid={props.sequenceId}
          shotID={props.shotID}
          projectId={props.projectId}
          status={props.status}
          shotVersionId={props.data.id}
          handleEditShotVersionModalOpenState={
            handleEditShotVersionModalOpenState
          }
          openDeleteShotVersionModal={handleDeleteShotVersionModalOpenState}
          updateRefreshCounter={props.updateRefreshCounter}
          dragScreen={props.dragScreen}
          setDragFileEnterModal={props.setDragFileEnterModal}
          taskList={props.taskList}
          fetchTasks={props.fetchTasks}
          customFields={props.customFields}
        />
      </Modal>

      <Modal
        className={classes.shotVersionPageModals}
        open={isDeleteShotVersionModalOpen}
        onClose={(e) => {
          setDeleteShotVersionModalOpen(false);
          e.stopPropagation();
        }}
      >
        <DeleteModal
          type="Shot Version"
          name={deleteData?.name}
          handleCloseDeleteModal={() => {
            setDeleteShotVersionModalOpen(false);
          }}
          handleDelete={handleDeleteShotVersion}
        />
      </Modal>
    </>
  );
}
